<nz-select
  [formControl]="formPart"
  nzShowSearch
  nzServerSearch
  nzAllowClear
  nzPlaceHolder="Select a buyer"
  data-testid="buyerDSPSeatID"
  [nzLoading]="isLoading"
  (nzOnSearch)="onSearch($event)"
  (nzScrollToBottom)="onScrollToBottom()">
  <nz-option *ngFor="let buyer of buyers"
             [nzLabel]="buyer.name + ' (' + buyer.id + ')'"
             [nzValue]="buyer.id">
  </nz-option>
</nz-select>
